<p class="user-title">{{ loginName }}, welcome to iAudit</p>
<p class="user-tasks">Today, <span class="user-tasks-count">{{taskCount}}</span> tasks are waiting for your action in iAudit</p>
